import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';

import { PrCmpa, ProductCmpaService } from '../../services/product-cmpa.service';
import { ProductTypeService } from '../../services/product-type.service';
import { UnitService } from '../../services/unit.service';
import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';

import { ISubscription, Subscription } from "rxjs/Subscription";
import { CustomerBillData } from '../../services/customer-bill.service';
import { Utils } from '../../util';

@Component({
  selector: 'app-create-pr-cmpa',
  templateUrl: './create-pr-cmpa.component.html',
  styleUrls: ['./create-pr-cmpa.component.css']
})
export class CreatePrCmpaComponent implements OnInit, OnDestroy {

  defaultIva: number = 0;

  classError: boolean = false;
  unitError: boolean = false;
  unitErrors: boolean[] = [];
  supplierError: boolean = false;

  modalActionsCharac = new EventEmitter<string|MaterializeAction>();
  modalParamsCharac = [{dismissible: true}];
  modalActionsPrice = new EventEmitter<string|MaterializeAction>();
  modalParamsPrice = [{dismissible: true}];
  
  prCmpaForm: FormGroup;
  currencySelect: any[] = [];
  charactForm: FormGroup;
  priceForm: FormGroup;

  characs = [];
  prices = [];

  classns = {};
  units = {};
  suppliers = {};

  highestCode: {[chars: string]: string} = {};

  classnsInit: any;
  unitsInit: any;
  suppliersInit: any;

  subs: Subscription[] = [];

  newArray(length: number){
    return [...new Array(length)].map((u, i) => i);
  }
  constructor(
    private prCmpaService: ProductCmpaService,
    private classnService: ProductTypeService,
    private unitService: UnitService,
    private supplierService: CustomerSupplierService,
    private settings: CatalogsSettingsService,
    private customerBillData: CustomerBillData,
    private fb: FormBuilder,
  ) {
    this.subs.push(
      this.settings.getPayrollSettings('1').subscribe(settings => {
        this.defaultIva = settings.defaults && settings.defaults.iva || 0;
      })
    );
  }

  ngOnInit() {
    this.createForm();
    this.createFormCharac();
    this.createFormPrice();
    this.subs.push(
      this.classnService.getPrCTypes().subscribe(classns => {
        const data = classns.reduce((acc, cur) => {
          acc[`${cur.name.trim()}`] = null;
          this.classns[`${cur.name.trim()}`] = {id: cur.id, code: cur.code};
          return acc;
        }, {});
        this.classnsInit = {
          'data': data
        };
      })
    );
    this.subs.push(
      this.unitService.getUnits().subscribe(units => {
        const data = units.reduce((acc, cur) => {
          acc[`${cur.name.trim()}`] = null;
          this.units[`${cur.name.trim()}`] = cur.id;
          return acc;
        }, {});
        this.unitsInit = {
          'data': data
        };
      })
    );
    this.subs.push(
      this.supplierService.getSuppliers().subscribe(suppliers => {
        const data = suppliers.reduce((acc, cur) => {
          acc[`${cur.name.trim()}`] = null;
          this.suppliers[`${cur.name.trim()}`] = cur.id$;
          return acc;
        }, {});
        this.suppliersInit = {
          'data': data
        }
      })
    );
    let prCmpasSub = this.prCmpaService.getPrCmpas().subscribe(prCmpas => {
      prCmpas.map(prCmpa => {
        let str: string = '';
        let num: number;
        for(let char of prCmpa.code){
          if(isNaN(+char)) str += char;
          else num = +`${num || ''}${char}`;
        }
        let biggest = this.highestCode[str] || '0000';
        let next = Utils.String.fillLeft(`${num + 1}`, '0', 4);
        if(biggest < next) this.highestCode[str] = next;
      });
    });
    this.subs.push(prCmpasSub);
  }
  ngOnDestroy(){
    this.subs.map((sub, index) => {
      this.subs[index].unsubscribe();
    });
  }
  

  createForm() {
    this.prCmpaForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      activeComponent: '',
      code: ['', Validators.required],
      classnId: ['', Validators.required],
      unitName: '',
      reorderQuantity: '',
      lastPriceUsed: 0,
    });
    this.currencySelect = this.customerBillData.allSelects.currency;
  }
  createFormCharac() {
    this.charactForm = this.fb.group({
      name: ['', Validators.required],
      value: ['', Validators.required],
      unitId: ['', Validators.required],
    });
  }
  createFormPrice() {
    this.priceForm = this.fb.group({
      price: ['', Validators.required],
      supplierId: ['', Validators.required],
      usesIva: [''],
      amountIva: [''],
      currency: 'key0',
    });
  }

  addCharact({ value, valid }: { value: any, valid: boolean }) {
    value.nameUnit = value.unitId;
    value.unitId = this.units[value.unitId];  
    if(value.unitId != undefined){
      this.characs.push(value);
      this.charactForm.reset();
      this.unitError = false;
      //this.closeModalCharac();
    }else{
      this.unitError = true;
      this.charactForm.get('unitId').reset();
    }
  }
  changeCharacUnit(index: number){
    let charac = this.characs[index];
    console.log(this.units, this.units[charac.nameUnit]);
    charac.unitId = this.units[charac.nameUnit];  
    if(charac.unitId == undefined){
      charac.nameUnit = '';
      this.unitErrors[index] = true;
    }else{
      this.unitErrors[index] = false;
    }
  }
  deleteCharact(index) {
    this.characs.splice(index,1);
  }
  addPrice({ value, valid }: { value: any, valid: boolean }) {
    value.supplierName = value.supplierId;
    value.supplierId = this.suppliers[value.supplierId];
    if(value.amountIva == null){
      value.amountIva = 0;
    }
    if(value.supplierId != undefined){
      this.prices.push(value);
      this.closeModalPrice();
    }else{
      this.supplierError = true;
      this.priceForm.get('supplierId').reset();
    }
  }
  deletePrice(index) {
    this.prices.splice(index,1);
  }

  onSubmit({ value, valid }: { value: any, valid: boolean }) {
    let unitId = value.unitName ? this.units[value.unitName] : '';
    if(value.unitName && !unitId) return toast('La unidad de compra no es válida');
    delete value.unitName;
    value.unitRef = unitId ? this.unitService.getDocRef(unitId) : null;
    value.classnId = this.classns[value.classnId].id;
    value.characs = this.characs;
    value.prices = this.prices;
    value.name = value.name.trim();

    this.prCmpaService.addPrCmpa(value);
    this.prCmpaService.router.navigate(['/prCmpa']);
  }

  onChangeClass(name: string){
    let classn = this.classns[name];
    this.classError = !classn;
    if(this.classError) return;
    let code = `${classn.code}-${this.highestCode[`${classn.code}-`] || '0000'}`;
    this.prCmpaForm.get('code').patchValue(code);
  }

  openModalCharac() {
    this.charactForm.reset();
    this.unitError = false;
    this.modalActionsCharac.emit({ action: 'modal', params: ['open'] });
  }
  closeModalCharac() {
    this.modalActionsCharac.emit({ action: 'modal', params: ['close'] });
  }
  openModalPrice() {
    this.priceForm.reset();
    this.priceForm.get('usesIva').patchValue(true);
    this.priceForm.get('amountIva').patchValue(this.defaultIva);
    this.supplierError = false;
    this.modalActionsPrice.emit({ action: 'modal', params: ['open'] });
  }
  closeModalPrice() {
    this.modalActionsPrice.emit({ action: 'modal', params: ['close'] });
  }

}
